import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import {
    IAuthFailureLog,
    IAuthFailureLogResponse,
    ISendOtpCode,
    ISendOtpCodeResponse,
    IValidateUser,
    IValidateUserResponse,
    IVerifyOtpCode,
    IVerifyOtpCodeResponse,
} from "../types/auth.types";
import {
    encryptAuthFailureEmail,
    sendOtpCode,
    validateUser,
    verifyOtpCode,
} from "../services/auth.services";

export function useValidateUser() {
    return useMutation<
        IValidateUserResponse,
        AxiosError<IValidateUserResponse>,
        IValidateUser
    >({
        mutationKey: ["validate-user"],
        mutationFn: (payload: IValidateUser) => validateUser(payload),
    });
}

export function useEncryptAuthFailureEmail() {
    return useMutation<
        IAuthFailureLogResponse,
        AxiosError<IAuthFailureLogResponse>,
        IAuthFailureLog
    >({
        mutationKey: ["post-auth-failure-log"],
        mutationFn: (payload: IAuthFailureLog) =>
            encryptAuthFailureEmail(payload),
    });
}

export function useSendOtpCode() {
    return useMutation<
        ISendOtpCodeResponse,
        AxiosError<ISendOtpCodeResponse>,
        ISendOtpCode
    >({
        mutationKey: ["send-otp-code"],
        mutationFn: (payload: ISendOtpCode) => sendOtpCode(payload),
    });
}

export function useVerifyOtpCode() {
    return useMutation<
        IVerifyOtpCodeResponse,
        AxiosError<IVerifyOtpCodeResponse>,
        IVerifyOtpCode
    >({
        mutationKey: ["verify-otp-code"],
        mutationFn: (payload: IVerifyOtpCode) => verifyOtpCode(payload),
    });
}
